import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { connect, useDispatch } from 'react-redux'
import { Layout } from 'antd'
import { RouteComponentProps } from 'react-router-dom'
import moment from 'moment'
import RootState from 'typings/RootState'
import {
  selectReport,
  selectDefect,
  selectEvent,
} from 'features/report/constructRoad/selector'

import {
  userEmailSelector,
  serviceTokenSelector,
} from 'features/sensitive/sensitive.selector'
import { selectUploadEvent } from 'features/uploadfile/selector'
import ConstructRoadReport from 'Components/ConstructRoad/Report'
import EventModal from 'Components/Shared/Modal/EventModal'

import { fromRoute } from 'utils/helper'

import Breadcrumbs from './Breadcrumbs'
import QcFooter from './QcFooter'
import Signature from './Signature'
import ChoosePin from './ChoosePin'
import { BreadcrumbLink } from 'Components/Shared/BreadCrumb/BreadCrumb'

const { Content } = Layout

type Props = RouteComponentProps<{
  project: string
  unit: string
  qcTypeID: string
  requestID: string
  checkNumber: string
}> &
  ReduxProps

const QcConstructRoadReport: React.ComponentType<Props> = props => {
  const [page, setPage] = useState('')
  const [refresh, setRefresh] = useState(0)
  const [enableModal, setEnableModal] = useState(false)
  const [displaySign, setDisplaySign] = useState(false)
  const [displaySelectPin, setDisplaySelectPin] = useState(false)
  const {
    UserEmail,
    Token,
    report,
    defect,
    event,
    uploadEvent,
    history,
    match,
  } = props

  const { project, unit, qcTypeID, requestID, checkNumber } = match.params
  const Unit = fromRoute(unit)
  const RequestID = +requestID || 0
  const CheckNumber = +checkNumber || 0
  const dispatch = useDispatch()

  const getName = () => {
    switch (page) {
      case 'add.defect':
        return 'เพิ่ม Defect'
      case 'edit.defect':
        return 'แก้ไข Defect'
      case 'view.defect':
        return `หมุดที่ ${defect.PinNumber}`
      default:
        return undefined
    }
  }

  const gotoDashboard = () => {
    setEnableModal(false)
    history.push('/construct-road')
  }

  const closeEnableModal = () => setEnableModal(false)
  const onRefreshPage = () => {
    onClear()
    setRefresh(moment().unix())
  }

  const onClear = () => {
    setEnableModal(false)
    setDisplaySign(false)
    setPage('')
  }

  let addMode = false
  let readOnly = true
  if (report.State === 'QC' && report.Status === 'INPRO') {
    addMode = true
    readOnly = false
  }

  if (displaySelectPin) {
    return (
      <ChoosePin
        onClose={() => setDisplaySelectPin(false)}
        onCompleted={() => {
          setDisplaySelectPin(false)
          onRefreshPage()
        }}
        ProjectCode={project}
        Unit={unit}
        QCTypeID={qcTypeID}
        RequestID={RequestID}
        CheckNumber={CheckNumber}
      />
    )
  }

  const breadcrumbs: BreadcrumbLink[] = [
    {
      url: '/construct-road',
      title: 'Home',
      icon: '/home.png',
      active: true,
      showTitle: false,
    },
    {
      url: '/construct-road',
      title: 'ถนน',
      active: true,
      showTitle: true,
    },
    {
      url: ``,
      title: 'ระหว่างก่อสร้างถนน',
      active: true,
      showTitle: true,
      onClick: () => setPage(''),
    },
  ]

  return (
    <>
      <EventModal
        event={[event]}
        err={[uploadEvent]}
        enable={enableModal}
        successCalback={gotoDashboard}
        errorCalback={closeEnableModal}
      />
      <Signature
        display={displaySign}
        project={project}
        Unit={Unit}
        QCTypeID={qcTypeID}
        RequestID={RequestID}
        CheckNumber={CheckNumber}
        onClose={() => setDisplaySign(false)}
        onCompleted={onRefreshPage}
      />
      {page !== 'activity' && (
        <Breadcrumbs
          path={`/construct-road/report/${project}/${unit}/${qcTypeID}/${RequestID}/${CheckNumber}`}
          title="ระหว่างก่อสร้างถนน"
          name={getName()}
          onBack={() => setPage('')}
        />
      )}
      <ConstructRoadReport
        title={'ระหว่างก่อสร้างถนน'}
        initPage={page}
        ProjectCode={project}
        Unit={Unit}
        QCTypeID={qcTypeID}
        RequestID={RequestID}
        CheckNumber={CheckNumber}
        onPage={(name: string) => setPage(name)}
        addMode={addMode}
        readOnly={readOnly}
        refresh={refresh}
        breadcrumbs={breadcrumbs}
      />
      <QcFooter
        report={report}
        visible={page === ''}
        onSign={() => setDisplaySign(true)}
        onSelectPin={() => setDisplaySelectPin(true)}
      />
    </>
  )
}

const MainPage = styled.div`
  background-color: #f5f6fa;
`

const mapStateToProps = (state: RootState) => {
  return {
    Token: serviceTokenSelector(state),
    UserEmail: userEmailSelector(state),
    report: selectReport(state),
    defect: selectDefect(state),
    event: selectEvent(state),
    uploadEvent: selectUploadEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QcConstructRoadReport)
